import { useEffect, useMemo, useState } from "react";
import { API_BASE } from "./utils";
import { resolveMediaUrl } from "./media-api";
import { getAuthHeaders } from "./auth-fetch";

// const API_BASE = typeof window !== "undefined" ? "" : "http://localhost:8000";

const EMPTY_EVENT = {
  id: "",
  slug: "",
  handle: "",
  title: "Event",
  subtitle: "",
  venue: "",
  timezone: "",
  startDate: "",
  endDate: "",
  capacity: 0,
  registered: 0,
  checkedIn: 0,
  revenue: 0,
  status: "",
  accent: "var(--primary)",
  cover: "",
};

export function useEventMeta(eventId) {
  const [event, setEvent] = useState({ ...EMPTY_EVENT, id: eventId || "" });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/events`, { headers: getAuthHeaders() });
        if (res.ok) {
          const payload = await res.json();
          const events = Array.isArray(payload?.events) ? payload.events : [];
          const found = events.find((row) => row.id === eventId || row.slug === eventId);
          if (!cancelled && found) {
            setEvent({ ...EMPTY_EVENT, ...found });
            return;
          }
        }
        if (!eventId) return;
        const overviewRes = await fetch(`${API_BASE}/api/admin/events/${eventId}/overview`, {
          headers: getAuthHeaders(),
        });
        if (!overviewRes.ok) return;
        const overview = await overviewRes.json();
        if (!cancelled && overview?.event) setEvent({ ...EMPTY_EVENT, ...overview.event });
      } catch {
        // Keep neutral fallback for API outages.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  return useMemo(() => {
    const merged = { ...EMPTY_EVENT, ...event, id: event.id || eventId || "" };
    const cover = resolveMediaUrl(merged.cover) || merged.cover || "";
    const logo = resolveMediaUrl(merged.logo) || merged.logo || "";
    return { ...merged, cover, logo };
  }, [event, eventId]);
}
